import React, { useState } from "react";
import { motion } from "framer-motion";
import { IoPlay } from "react-icons/io5";
import { PiPauseFill } from "react-icons/pi";
import { BsPlusCircle } from "react-icons/bs";
import VolumeControl from "./common/volumeControl";

const MusicControl = ({
  currentSong,
  isChosed,
  isPlaying,
  isWebPlayer = false,
  onPlay,
  onPause,
  volume,
  setVolume,
  onSelect,
  onRemove,
  currentTime = 0,
  duration = 30,
  onSeek,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleButtonClick = () => {
    if (isChosed) {
      onRemove(currentSong);
    } else {
      onSelect(currentSong);
    }
  };

  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const handleProgressClick = (e) => {
    if (!onSeek || !duration) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = x / rect.width;
    const newTime = percentage * duration;

    onSeek(newTime);
  };

  const handleProgressDrag = (e) => {
    if (!isDragging || !onSeek || !duration) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
    const percentage = x / rect.width;
    const newTime = percentage * duration;

    onSeek(newTime);
  };

  const progress = duration > 0 ? (currentTime / duration) * 100 : 0;

  const helper = () => {
    return !isWebPlayer ? (
      <motion.div
        className="music-control-container mc-variant"
        animate={{ opacity: currentSong ? 0 : 1 }}
        transition={{ duration: 3, ease: "easeInOut" }} //FIXME
        style={{ backgroundColor: "#FCE868" }}
      >
        <p className="font-subT5-WS" style={{ margin: "0px 0px 0px 0px" }}>
          Cerca dalla searchbar{" "}
          <span className="no-phone">o con le sezioni di sinistra.</span>
          <span className="phone">o dai 3 menù.</span>
        </p>
        <h2
          className="font-subT2-Osw-mc-variant"
          style={{ lineHeight: "32px", margin: "0px 0px 0px 0px" }}
        >
          Clicca un brano per ascoltare l'anteprima.
        </h2>
      </motion.div>
    ) : (
      <motion.div
        className="music-control-container mc-variant mc-variant-web-player"
        animate={{ opacity: currentSong ? 0 : 1 }}
        transition={{ duration: 3, ease: "easeInOut" }} //FIXME
        style={{ backgroundColor: "#FCE868" }}
      >
        <h2
          className="font-subT2-Osw-mc-variant"
          style={{ lineHeight: "32px", margin: "0px 0px 0px 0px" }}
        >
          Clicca un brano per avviare il player.
        </h2>
      </motion.div>
    );
  };

  return currentSong ? (
    <motion.div
      className="music-control-container mc-variant-web-player"
      style={{
        border: "none",
        display: "flex",
        flexDirection: "column",
      }}
      animate={{ opacity: currentSong ? 1 : 0 }}
      transition={{ duration: 3, ease: "easeInOut" }} //FIXME
    >
      {/* Progress Bar */}
      {isWebPlayer && (
        <div
        style={{
          width: "100%",
          padding: "8px 16px 0",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
        >
        <span style={{ fontSize: "12px", color: "#2C2B26", minWidth: "35px" }}>
          {formatTime(currentTime)}
        </span>
        <div
          style={{
            flex: 1,
            height: "6px",
            backgroundColor: "#E2D6BE",
            borderRadius: "3px",
            cursor: "pointer",
            position: "relative",
          }}
          onClick={handleProgressClick}
          onMouseDown={() => setIsDragging(true)}
          onMouseUp={() => setIsDragging(false)}
          onMouseLeave={() => setIsDragging(false)}
          onMouseMove={handleProgressDrag}
          >
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              width: `${progress}%`,
              backgroundColor: "#FF6B35",
              borderRadius: "3px",
              transition: isDragging ? "none" : "width 0.1s linear",
            }}
            />
          <div
            style={{
              position: "absolute",
              left: `${progress}%`,
              top: "50%",
              transform: "translate(-50%, -50%)",
              width: "14px",
              height: "14px",
              backgroundColor: "#FF6B35",
              borderRadius: "50%",
              border: "2px solid #FFFDEF",
              cursor: "grab",
              transition: isDragging ? "none" : "left 0.1s linear",
            }}
            />
        </div>
        <span style={{ fontSize: "12px", color: "#2C2B26", minWidth: "35px" }}>
          {formatTime(duration)}
        </span>
      </div>
    )}

      {/* Player Controls */}
      <div className="mc-controls">

        <div
        style={{
          display: "flex",
            alignItems: "center",
            wrap: "nowrap !important",
            padding: "8px 16px 12px",
            gap: "16px",
          }}
        >
          <button
            className="mc-play-pause-btn"
            onClick={isPlaying ? onPause : () => onPlay(currentSong)}
          >
            <div className={`${isPlaying ? "mc-pause-icon" : "mc-play-icon"}`}>
              {isPlaying ? <PiPauseFill /> : <IoPlay />}
            </div>
          </button>
          <div className="mc-track-info" style={{ flex: 1 }}>
            <p
              className="mc-title"
              style={{
                whiteSpace: "nowrap",
              }}
            >
              {currentSong.Title}
            </p>
            <p className="mc-artist">{currentSong.Stage_Name}</p>
          </div>
          <div className="d-flex flex-column align-items-end">
            {!isWebPlayer && (
              <div
                className={`mc-add-button ${isChosed ? "chosed" : ""}`}
                onClick={handleButtonClick}
              >
                <BsPlusCircle fontSize={"30px"} />
              </div>
            )}
            <VolumeControl volume={volume} setVolume={setVolume} />
          </div>
        </div>
      </div>
    </motion.div>
  ) : (
    helper()
  );
};

export default React.memo(MusicControl);
